import Button from 'components/_parts/atoms/button';
import Label from 'components/_parts/atoms/label';
import TooltipCustom from 'components/_parts/atoms/tooltip';
import { processLabel } from 'components/types/businessProcess';
import labelBp from './label';

function Steering({ val, setSelectedData }: processLabel) {
  const labelSteering = labelBp('steering');
  return (
    <div
      id="cvc-steering"
      key={val.process_id}
      aria-hidden="true"
      className="custm_list_cvc gap20Cvc pointer"
      onClick={() => {
        setSelectedData({
          lvl: '2',
          process_id: val.process_id,
          type: labelSteering,
          backgroundColor: '#79FF39',
          name: val.name,
          order: val.order,
        });
      }}
    >
      <Button
        style={{
          width: '28px',
          height: '28px',
          backgroundColor: '#79FF39',
          boxShadow: '0 4px 4px 0 rgba(0,0,0,0.3)',
        }}
      >
        {val.no}
      </Button>
      <TooltipCustom name={val?.name}>
        <Label className="clampTitle">{val?.name}</Label>
      </TooltipCustom>
      <Button
        style={{
          backgroundColor: '#79FF39',
          height: '20px',
          padding: '0px 20px',
          fontWeight: '600',
          marginLeft: 'auto',
        }}
      >
        {labelSteering}
      </Button>
    </div>
  );
}

export default Steering;
